import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, BookOpen, Building2, CreditCard, ShoppingCart, FolderOpen, Tags, Newspaper, LogOut } from "lucide-react";
import { adminApi } from "../../lib/api";

const NAV = [
  { to: "/apadmin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/apadmin/magazines", label: "Magazines", icon: BookOpen },
  { to: "/apadmin/publishers", label: "Publishers", icon: Building2 },
  { to: "/apadmin/plans", label: "Plans", icon: CreditCard },
  { to: "/apadmin/categories", label: "Categories", icon: Tags },
  { to: "/apadmin/blog", label: "Blog", icon: Newspaper },
  { to: "/apadmin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/apadmin/uploads", label: "Uploads", icon: FolderOpen },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    adminApi.get("/auth/me")
      .then((u) => { setUser(u); setChecked(true); })
      .catch(() => { localStorage.removeItem("bm_admin_token"); navigate("/apadmin/login"); });
  }, [navigate]);

  if (!checked) return <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center text-zinc-500" data-testid="admin-loading">Loading...</div>;

  return (
    <div className="min-h-screen bg-[#F4F4F5] font-body flex" data-testid="admin-layout">
      <aside className="w-56 shrink-0 bg-white border-r border-zinc-200 min-h-screen fixed inset-y-0 left-0 hidden md:flex flex-col" data-testid="admin-sidebar">
        <div className="px-5 py-5 border-b border-zinc-200">
          <span className="font-bold text-zinc-900">BookMala Admin</span>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors duration-150 ${isActive ? "text-zinc-900 font-semibold bg-zinc-100 border-r-2 border-zinc-900" : "text-zinc-500 hover:text-zinc-900"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-4 border-t border-zinc-200">
          <p className="text-xs text-zinc-500 truncate mb-2">{user?.email}</p>
          <button onClick={() => { localStorage.removeItem("bm_admin_token"); navigate("/apadmin/login"); }} data-testid="admin-logout-btn"
            className="flex items-center gap-2 text-xs text-zinc-500 hover:text-red-600">
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 md:ml-56">
        <div className="md:hidden bg-white border-b border-zinc-200 px-4 py-3 flex gap-3 overflow-x-auto" data-testid="admin-mobile-nav">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className="text-xs text-zinc-600 whitespace-nowrap">{n.label}</NavLink>)}
          <Link to="/apadmin/login" onClick={() => localStorage.removeItem("bm_admin_token")} className="text-xs text-red-600 whitespace-nowrap">Sign out</Link>
        </div>
        <main className="p-6">
          <Outlet context={{ user }} />
        </main>
      </div>
    </div>
  );
}
